import { render } from "./SuccessfulMatchView.vue?vue&type=template&id=6f429378"
import script from "./SuccessfulMatchView.vue?vue&type=script&lang=js"
export * from "./SuccessfulMatchView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__